import { render, staticRenderFns } from "./ReagentDilutionDrawer.vue?vue&type=template&id=07885f6a&scoped=true&"
import script from "./ReagentDilutionDrawer.vue?vue&type=script&lang=js&"
export * from "./ReagentDilutionDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ReagentDilutionDrawer.vue?vue&type=style&index=0&id=07885f6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07885f6a",
  null
  
)

export default component.exports